<template>
    <page-layout
        hide-footer
    >
        <template #header>
            <step-header
                :title="orderTitle"
                :is-loading="isLoading"
                :use-exit-modal="false"
                exit-route="v2.activation.brief.orders"
                skip-steps
            />
        </template>
        <template #default>
            <g-loader v-if="isLoading" type="fixed" />
            <template v-else>
                <g-row class="g-mb-5" align="bottom" type="flex">
                    <g-column type="flex" :span="18">
                        <product-shipping-info :brief="brief" :order="order" />
                        <g-typography v-if="missingAddress" italic> No Address </g-typography>
                    </g-column>
                    <g-column v-if="canEditShippingAddress" class="g-pb-4" type="flex" :span="6">
                        <g-button size="small" @click="goToShippingStep"> {{ goToShippingLabel }} </g-button>
                    </g-column>
                </g-row>
                <activation-brief-products-item
                    v-for="(product, index) in availableItems"
                    :key="`${product.id}_${index}`"
                    :options="getOrderOptionValuesByIndex(index)"
                    :product="product"
                    :brief="brief"
                />
            </template>
        </template>
    </page-layout>
</template>

<script>
    import { get } from 'lodash';
    import PageLayout from '../../../../layouts/PageLayout';
    import ActivationBriefOrderMixin from '../../mixins/ActivationBriefOrderMixin';
    import StepHeader from '../StepHeader';
    import ProductPreview from '../products/ProductPreview';
    import {pluralize} from '../../../../../helpers/string-helpers';
    import ProductShippingInfo from '../products/ProductShippingInfo';
    import ActivationBriefProductsItem from '../products/ActivationBriefProductsItem';
    import STEP_ROUTES from '../../../../../constants/activation-brief-step-routes';
    import {NAME_SHIPPING_INFO} from '../../../../../constants/activation-brief-steps';

    export default {
        name:       'ActivationBriefOrderView',
        components: {
            PageLayout,
            StepHeader,
            ProductPreview,
            ProductShippingInfo,
            ActivationBriefProductsItem,
        },
        mixins: [
            ActivationBriefOrderMixin,
        ],
        props: {
            isLoading: {
                type:    Boolean,
                default: false,
            },
            order: {
                type:     Object,
                required: true,
            },
            products: {
                type:     Array,
                default: [],
            }
        },
        computed: {
            availableItems() {
                return this.products.filter(product => !!product);
            },
            numItems() {
                return get(this, 'order.items', []).length;
            },
            orderTitle() {
                return `${this.numItems} ${pluralize(this.numItems, 'Item')}`;
            },
            canEditShippingAddress() {
                return !this.order.is_fulfilled;
            },
            missingAddress() {
                return !this.order.address_id;
            },
            goToShippingLabel() {
                return `${this.missingAddress ? 'Add' : 'Edit'} Address`;
            },
        },
        methods: {
            getOrderOptionValuesByIndex(index) {
                return get(this, `order.items[${index}].option_values`, []);
            },
            goToShippingStep() {
                return this.$router.push({
                    name: STEP_ROUTES[NAME_SHIPPING_INFO],
                    params: { isAdditionalOrder: true }
                });
            },
        },
    };
</script>
